(function() {
  let lastRun = 0;
  const delay = 150; // ms to throttle re-run frequency

  function formatVariantLabels() {
    document.querySelectorAll('.chevalnova-varient label').forEach(label => {
      if (label.querySelector('.label-price')) return;

      // Get visible text only (ignore accessibility text)
      const visibleText = Array.from(label.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && !node.classList?.contains('visually-hidden')))
        .map(node => node.textContent.trim())
        .join(' ')
        .trim();

      const priceMatch = visibleText.match(/(\d{1,2}[.,]\d{1,2}€\/kg)/);
      if (priceMatch) {
        const price = priceMatch[0];
        const mainText = visibleText.replace(price, '').trim();
        label.innerHTML = `
          <span class="label-main-text">${mainText}</span>
          <span class="label-price">${price}</span>
        `;
      }
    });
  }

  // Run initially
  document.addEventListener('DOMContentLoaded', formatVariantLabels);

  // Global observer — catches *any* DOM change on the page
  const observer = new MutationObserver(() => {
    const now = Date.now();
    if (now - lastRun > delay) {
      lastRun = now;
      formatVariantLabels();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

 $(document).on('click', '.ingredient-icon', function () {
        $(this).closest('.flip_box').toggleClass('flipped');
    });



    // ============================================
// PERSISTENT CART DRAWER QUANTITY LIMIT (for "Sac" products, message visible 2s)
// ============================================
(function () {
  const maxQty = 10;
  let observer = null;

  // ---- Core logic ----
  function enforceLimit() {
    const qtyInputs = document.querySelectorAll('.cart-item input.quantity__input');

    qtyInputs.forEach((input) => {
      if (input.dataset.limited === 'true') return;
      input.dataset.limited = 'true';

      input.addEventListener('input', () => checkQuantity(input));
      input.addEventListener('change', () => checkQuantity(input));
    });
  }

  // ---- Check + restrict ----
  function checkQuantity(input) {
    const cartItem = input.closest('.cart-item');
    const value = parseInt(input.value) || 1;

    const title = cartItem?.querySelector('.cart-item__name')?.innerText.toLowerCase() || '';
    const details = cartItem?.innerText.toLowerCase() || '';
    const isBag = title.includes('sac') || details.includes('conditionnement : sac');

    if (!isBag) return; // Skip pallets etc.

    if (value > maxQty) {
      input.value = maxQty;
      showLimitMessage();
    }
  }

  // ---- Message display (append AFTER form#CartDrawer-Form for 2s) ----
  function showLimitMessage() {
    const form = document.querySelector('form#CartDrawer-Form');
    if (!form) return;

    let msg = form.parentElement.querySelector('.quantity-limit-message');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'quantity-limit-message';
      msg.style.cssText =
        'color:#d0021b; font-size:14px; margin-top:10px; text-align:center; transition: opacity 0.4s ease;';
      msg.textContent =
        'Maximum 10 individual bags allowed. For larger orders, please select a pallet (10, 20, or 40 bags).';
      form.insertAdjacentElement('afterend', msg);
    }

    // ✅ Show message (reset opacity if hidden before)
    msg.style.opacity = '1';
    msg.style.display = 'block';

    // ✅ Hide after 2 seconds
    clearTimeout(msg.hideTimeout);
    msg.hideTimeout = setTimeout(() => {
      msg.style.opacity = '0';
      setTimeout(() => (msg.style.display = 'none'), 400);
    }, 2000);
  }

  // ---- Observe drawer for DOM changes ----
  function observeCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (observer) observer.disconnect();
    observer = new MutationObserver(() => enforceLimit());
    observer.observe(drawer, { childList: true, subtree: true });
  }

  // ---- Initialize ----
  document.addEventListener('DOMContentLoaded', () => {
    observeCartDrawer();
    enforceLimit();
  });
})();




// -----------------------------------------------------
// FINAL — QTY SLIDER + TIER + VARIANT SYNC + ECONOMY
// -----------------------------------------------------

// Custom js for Qty
document.addEventListener("DOMContentLoaded", function () {
  //console.log("🔥 Final Premium Slider + Variant Sync Loaded");

  let isSyncing = false;

  const slider = document.querySelector("#qty-slider");
  const bubble = document.querySelector("#qty-bubble");
  const dynamicPrice = document.querySelector("#dynamic-price");
  const shopifyQtyInput = document.querySelector("input.quantity__input");
  const tierCards = document.querySelectorAll(".tier-card");
  const addBtn = document.querySelector(".product-form__submit span");
  const ecoBox = document.querySelector("#eco-box");
  const ecoValue = document.querySelector("#eco-value");

  const minusBtn = document.querySelector("#minus-btn");
  const plusBtn = document.querySelector("#plus-btn");

  /* RANGE → VARIANT MAP */
const variantMapEl = document.querySelector("#variant-range-map");

if (!variantMapEl) {
  //console.error('#variant-range-map not found');
  return;
}

const rangeToVariantMap = JSON.parse(variantMapEl.textContent);

  /* UPDATE TIER PRICES */
  function updateTierPrices() {
    const variants = window.meta?.product?.variants || [];
    
document.querySelectorAll(".tier-price").forEach(el => {
  const variantId = rangeToVariantMap[el.dataset.range];
  const v = variants.find(x => x.id == variantId);
  if (!v) return;

  // Detect language → FR = sac, others = bag
  const isFrench = (window.Shopify?.locale || document.documentElement.lang || "fr").startsWith("fr");
  const unit = isFrench ? "sac" : "bag";

  el.textContent = (v.price / 100).toFixed(2).replace(".", ",") + "€/" + unit;
});
  }

  /* SLIDER BUBBLE + FILL */
 function updateBubble() {
  const val = slider.value;
  const min = slider.min;
  const max = slider.max;
  const percent = ((val - min) / (max - min)) * 100;

  // ⭐ LIMIT BUBBLE POSITION
  let bubblePos = percent;
  if (bubblePos < 4) bubblePos = 1;      // left edge limit
  if (bubblePos > 92) bubblePos = 92;    // right edge limit

  // Move bubble smoothly
  bubble.style.left = `calc(${bubblePos}% - 2%)`;
  bubble.textContent = val;

  // ⭐ Slider fill color
  slider.style.background = `linear-gradient(to right,
      #e76c35 0%,
      #e76c35 ${percent}%,
      #d7d1bd ${percent}%,
      #d7d1bd 100%)`;
}


  /* HIGHLIGHT CARD */
  function highlightCard(range) {
    tierCards.forEach(c =>
      c.classList.toggle("active", c.dataset.range === range)
    );
  }

  /* DISABLE SHOPIFY AUTOSCROLL */
  function runWithoutScroll(fn) {
    const old = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {};
    fn();
    setTimeout(() => Element.prototype.scrollIntoView = old, 80);
  }

  /* CORRECT RADIO SELECTOR MAP */
  const variantRadios = document.querySelectorAll('input[name^="Quantité"]');
  const dynamicLabelMap = {};
  variantRadios.forEach(r => dynamicLabelMap[r.value.trim()] = r.id);

  function selectVariant(range) {
    const id = dynamicLabelMap[range];
    if (!id) return;

    const label = document.querySelector(`label[for="${id}"]`);
    if (!label) return;

    runWithoutScroll(() => label.click());

    // Fix qty
    setTimeout(() => {
      shopifyQtyInput.value = slider.value;
      shopifyQtyInput.dispatchEvent(new Event("change"));
    }, 500);
  }

  /* ECONOMIE UI */
  function updateEco(range) {
    if (range === "4-7") {
      ecoBox.style.display = "block";
      ecoValue.textContent = "5%";
    } else if (range === "8-10") {
      ecoBox.style.display = "block";
      ecoValue.textContent = "10%";
    } else {
      ecoBox.style.display = "none";
    }
  }

  /* MAIN UPDATE */
  function update(qty) {
    if (isSyncing) return;
    isSyncing = true;

    qty = Math.max(1, Math.min(10, qty));
    slider.value = qty;
    updateBubble();

    if (shopifyQtyInput) shopifyQtyInput.value = qty;

    const range = qty <= 3 ? "1-3" : qty <= 7 ? "4-7" : "8-10";

    highlightCard(range);
    selectVariant(range);
    updateEco(range);

    function applyFreshPrice() {
      const variant = JSON.parse(
        document.querySelector("[data-selected-variant]").textContent
      );

      const total = (variant.price * qty / 100).toFixed(2).replace(".", ",") + "€";

      dynamicPrice.textContent = total;
     const locale = (window.Shopify?.locale || document.documentElement.lang || "fr").toLowerCase();
const addToCartText = locale.startsWith("en")
  ? "ADD TO CART"
  : "AJOUTER AU PANIER";

if (addBtn) addBtn.innerHTML = `${addToCartText} – ${total}`;
    }

    applyFreshPrice();
    setTimeout(applyFreshPrice, 1200);

    isSyncing = false;
  }

  /* INIT */
  updateTierPrices();
  update(1);

  slider.addEventListener("input", () => update(parseInt(slider.value)));
  minusBtn.addEventListener("click", () => update(parseInt(slider.value) - 1));
  plusBtn.addEventListener("click", () => update(parseInt(slider.value) + 1));
});






document.addEventListener("DOMContentLoaded", () => {
  const qtyContainer = document.querySelector(".qty-container");

  function updateQtyVisibility() {
    const activeLabel = document.querySelector('.product-form__input--pill input[type="radio"]:checked + label');

    //console.log("🎯 Active Label =", activeLabel);

    if (!activeLabel) return;

    const text = activeLabel.textContent.trim();
    //console.log("📝 Active Text =", text);

    if (text.includes("Sac 14 Kg")) {
      qtyContainer.style.display = "block";
    } else {
      qtyContainer.style.display = "none";
    }
  }

  // When ANY radio changes anywhere in form → update state
  document.addEventListener("change", (e) => {
    if (e.target.matches('.product-form__input--pill input[type="radio"]')) {
      updateQtyVisibility();
    }
  });

  // MutationObserver for Avada or Shopify re-render
  const obs = new MutationObserver(updateQtyVisibility);
  obs.observe(document.body, { childList: true, subtree: true });

  // Initial
  updateQtyVisibility();
});

